export default [
  "zoom",
  "preload",
  "thumbnail",
  "sensitivity",
  "shadow.intensity",
  "shadow.softness",
  "hint.finger",
  "autorotate.enable",
  "autorotate.delay",
  "autorotate.speed",
  "animation.autoplay",
  "animation.timeScale",
  "animation.crossfadeDuration",
  "animation.name",
  "ar.enable",
  "ar.zoom",
  "ar.placement",
  "ar.xrEnvironment",
];
